import { isSuperAdmin, isBrandAdmin, isBranchAdmin } from './portalRoles';

export const ownerLevelFromItem = (item = {}) => {
  if (item.ownerLevel) return item.ownerLevel;
  if (item.scope === 'branch' || item.salon) return 'branch';
  if (item.scope === 'brand' || item.brand) return 'brand';
  return 'platform';
};

const idOf = (value) => {
  if (value == null || value === '') return '';
  if (typeof value === 'object') return String(value.id || value._id || '');
  return String(value);
};

const itemSalonId = (item) => {
  if (item?.salon) return idOf(item.salon);
  if (Array.isArray(item?.salons) && item.salons.length) return idOf(item.salons[0]);
  return '';
};

/** Lower admins may edit/delete only rows they own. Super can mutate all. */
export const canMutateCatalogItem = (portal, item) => {
  if (!portal || !item) return false;
  if (portal.isSuperAdmin || isSuperAdmin(portal.role)) return true;
  const level = ownerLevelFromItem(item);
  if (portal.isBrandAdmin || isBrandAdmin(portal.role)) {
    return level === 'brand' && idOf(item.brand) === String(portal.brandId || '');
  }
  if (portal.isBranchAdmin || isBranchAdmin(portal.role)) {
    return level === 'branch' && itemSalonId(item) === String(portal.salonId || '');
  }
  return false;
};

export const canDuplicateCatalogItem = (portal, item) => {
  if (!portal || !item) return false;
  if (portal.isSuperAdmin || isSuperAdmin(portal.role)) return false;
  return !canMutateCatalogItem(portal, item);
};

export const ownerLevelLabel = (item) => {
  const level = ownerLevelFromItem(item);
  if (level === 'platform') return 'From Super Admin';
  if (level === 'brand') return 'From brand';
  return 'This branch';
};

